import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgSofort({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.498 8.728a.88.88 0 01.178.187.914.914 0 01.146.647h.647l-.975 2.68h.974l.976-2.68h1.252L22 8.728h-3.502zm-1.333.615h-.18l-.315.85h.186c.356 0 .544-.174.648-.455.111-.3-.011-.395-.34-.395zm-8.807.014c.334 0 .41.194.117.996-.301.825-.52 1.032-.848 1.032h-.001c-.32 0-.433-.203-.133-1.024.224-.612.514-1.004.865-1.004zm5.825 0c-.35 0-.641.392-.865 1.005-.3.82-.188 1.023.133 1.023.33 0 .548-.207.85-1.032.293-.802.216-.995-.118-.996z"
        fill="#EE7F00"
      />
    </svg>
  )
}

export default SvgSofort
